import { useMemo } from 'react';

import integration from 'src/lib/api/pagerduty-ui/integration';
import { getQueryParams } from 'src/lib/history';
import { usePromise } from 'src/lib/hooks';

import { useIncident } from './incident';

let projectIssueTypesPromise = null;

export const useProjectIssueTypes = () => {
  const {
    incident,
    loading: incidentLoading,
    error: incidentError,
  } = useIncident();

  const { accounts_mapping_id: accountsMappingId } = getQueryParams();

  const { data, loading, error } = usePromise(() => {
    if (!incident && !incidentLoading) {
      return Promise.reject(incidentError || 'Failed to load an incident.');
    } else if (!accountsMappingId) {
      return Promise.reject('Accounts Mapping ID is required.');
    } else if (incident) {
      if (!projectIssueTypesPromise) {
        projectIssueTypesPromise = integration.getProjectIssueTypes(accountsMappingId, incident.service.id);
      }
      return projectIssueTypesPromise;
    }
    return new Promise(() => {});
  }, [incident, incidentLoading, accountsMappingId]);

  return useMemo(() => ({
    projectIssueTypes: data,
    loading,
    error
  }), [data, loading, error]);
};
